export default __webpack_public_path__ + "static/media/bioHeadshot.f1d61f9b.jpg";